const STORAGE_KEY = 'sonny.onboarding.sessionId';

function canUseSessionStorage(): boolean {
  try {
    return typeof sessionStorage !== 'undefined';
  } catch {
    return false;
  }
}

export function setOnboardingSessionId(sessionId: string): void {
  if (sessionId === '' || !canUseSessionStorage()) {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, sessionId);
  } catch {
    // Private mode or storage disabled — profile lookup falls back to router state only.
  }
}

export function getOnboardingSessionId(): string | null {
  if (!canUseSessionStorage()) {
    return null;
  }
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    return value === '' ? null : value;
  } catch {
    return null;
  }
}

export function clearOnboardingSessionId(): void {
  if (!canUseSessionStorage()) {
    return;
  }
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function attachOnboardingSessionId<T extends Record<string, unknown>>(
  payload: T,
): T & { sessionId?: string } {
  const sessionId = getOnboardingSessionId();
  if (sessionId === null) {
    return payload;
  }
  return { ...payload, sessionId };
}
